import React, { createContext, FC, useContext, useMemo } from 'react';
import { Vector } from '@/GraphEditor/helpers/Vector';

export const PortPositionsContext = createContext<{
    setInPortPosition: (portName: string, position: Vector) => void;
    setOutPortPosition: (portName: string, position: Vector) => void;
}>({
    setInPortPosition: () => {},
    setOutPortPosition: () => {},
});

interface PortPositionsContextProviderProps {
    setInPortPosition: (portName: string, position: Vector) => void;
    setOutPortPosition: (portName: string, position: Vector) => void;
    children: React.ReactNode;
}

export const PortPositionsContextProvider: FC<PortPositionsContextProviderProps> = props => {
    const value = useMemo(
        () => ({
            setInPortPosition: props.setInPortPosition,
            setOutPortPosition: props.setOutPortPosition,
        }),
        [props.setInPortPosition, props.setOutPortPosition],
    );
    return <PortPositionsContext.Provider value={value}>{props.children}</PortPositionsContext.Provider>;
};

export function usePortPositions() {
    return useContext(PortPositionsContext);
}
